// src/config/whatsappConfig.js
export const WHATSAPP_CONFIG = {
  swingies: {
    enabled: process.env.REACT_APP_WHATSAPP_SWINGIES_ENABLED === "true",
    phoneNumber: process.env.REACT_APP_WHATSAPP_SWINGIES_PHONE,
    message: process.env.REACT_APP_WHATSAPP_SWINGIES_MESSAGE,
  },
  minimove: {
    enabled: process.env.REACT_APP_WHATSAPP_MINIMOVE_ENABLED === "true",
    phoneNumber: process.env.REACT_APP_WHATSAPP_MINIMOVE_PHONE,
    message: process.env.REACT_APP_WHATSAPP_MINIMOVE_MESSAGE,
  },
  default: {
    enabled: process.env.REACT_APP_WHATSAPP_DEFAULT_ENABLED === "true",
    phoneNumber: process.env.REACT_APP_WHATSAPP_DEFAULT_PHONE,
    message: process.env.REACT_APP_WHATSAPP_DEFAULT_MESSAGE,
  },
};
